import { CustomHeader } from "components/universal/custom-header";
import { useTranslation } from "react-i18next";
import { ResetPasswordPageView } from "views/reset-passwword-choice";

export const ResetPasswordPage = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.resetPasswordPage',
    });

    return (
        <>
            <CustomHeader title={t('title')} />
            <ResetPasswordPageView />
        </>
    );
};
